import { faAngleLeft, faAngleRight } from '@fortawesome/pro-regular-svg-icons'
import { ActionIcon, Button, Flex, Menu, SegmentedControl } from '@mantine/core'
import { MonthPicker } from '@mantine/dates'
import dayjs from 'dayjs'
import { useState } from 'react'

import { useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'

import { useSchedulerFilters } from '../../hooks/useSchedulerFilters'
import styles from './styles.module.css'

export function FiltersScheduler() {
  const { t, i18n } = useTranslation('saas', { keyPrefix: 'schedule' })

  const { startAt, showItems, setShowItems, goToMonth, nextMonth, prevMonth } =
    useSchedulerFilters()

  const [opened, setOpened] = useState(false)

  const statusFilters = [
    {
      label: t('filters.all'),
      value: 'all',
    },
    {
      label: t('filters.active'),
      value: 'active',
    },
  ]

  return (
    <Flex>
      <SegmentedControl
        mr='md'
        size='md'
        radius='sm'
        data={statusFilters}
        value={showItems}
        onChange={(value) => setShowItems(value as 'all' | 'active')}
      />
      <Flex align='center' gap='sm'>
        <ActionIcon variant='default' onClick={prevMonth}>
          <Icon icon={faAngleLeft} />
        </ActionIcon>
        <Menu opened={opened} onChange={setOpened}>
          <Menu.Target>
            <Button variant='default' miw={180} tt='capitalize'>
              {dayjs(startAt).locale(i18n.language).format('MMMM / YYYY')}
            </Button>
          </Menu.Target>
          <Menu.Dropdown w={280}>
            <MonthPicker
              size='md'
              className={styles.monthPicker}
              value={dayjs(startAt).toDate()}
              lang={i18n.language}
              onChange={(date) => {
                if (date) {
                  const value = dayjs(date)
                    .startOf('month')
                    .format('YYYY-MM-DD')

                  goToMonth(value)
                }

                setOpened(false)
              }}
            />
          </Menu.Dropdown>
        </Menu>
        <ActionIcon variant='default' onClick={nextMonth}>
          <Icon icon={faAngleRight} />
        </ActionIcon>
      </Flex>
    </Flex>
  )
}
